import { lazy } from 'react'
import InvoicesLoaderFactory from './loader'
import EditInvoiceLoader from './edit/loader'
import invoiceHistoryLoader from './history/loader'

export default {
  Invoices: {
    Component: lazy(() => import('./Invoices.Page')),
    LoaderFactory: InvoicesLoaderFactory,
  },
  InvoiceHistory: {
    Component: lazy(() => import('./history/InvoiceHistory.Page')),
    Loader: invoiceHistoryLoader,
  },
  EditInvoice: {
    Component: lazy(() => import('./edit/EditInvoice.Page')),
    Loader: EditInvoiceLoader,
  },
}
